import React from 'react'

import {
  Card,
} from 'components'
import { SPACING } from 'utils'

import { DashboardProvider, useDashboard } from './context'
import ReportForm from './components/ReportForm'
import ReportView from './components/ReportView'

const DashboardComponent: React.FC = () => {
  const {
    viewGraphic
  } = useDashboard()

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        marginTop={SPACING.spacing50}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        {
          !viewGraphic
            ? <ReportForm />
            : <ReportView />
        }
      </Card>
    </>
  )
}

const Dashboard: React.FC = () => {
  return (
    <DashboardProvider>
      <DashboardComponent />
    </DashboardProvider>
  )
}

export default Dashboard
